import { useContext } from 'react'

import { isChildNull } from 'core-components/classes/helpers/isChildNull'
import { SiteBuilderContext } from 'core-components/sitebuilder/layout/context/SiteBuilderContext'
import { EmptyWidget } from 'core-components/sitebuilder/layout/widgetCreator/EmptyWidget'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { IWidgetProps } from 'core-components/sitebuilder/models/IWidgetProps'

interface IWidgetsCreator {
  viewModel: string
  widgetParams: Record<string, any>
  widgetWidth: number
  flexWidth: FlexDirectionBreak
  staticParams: Record<string, any>
  routeParams: Record<string, any>
  metrics: any
  onChangeCustomSettings: (newCustomSettings: unknown) => void
  onToggleColumnWidth: () => void
  fullWidth: boolean
  customSettings: Record<string, any>
  isFullScreen: boolean
  onCloseFullScreen: () => void
  onOpenFullScreen: () => void
}

export const WidgetsCreator = ({
  staticParams,
  routeParams,
  widgetParams,
  metrics,
  flexWidth,
  onChangeCustomSettings,
  widgetWidth,
  onToggleColumnWidth,
  fullWidth,
  customSettings,
  isFullScreen,
  onCloseFullScreen,
  onOpenFullScreen,
  viewModel,
}: IWidgetsCreator) => {
  const { AppWidgets } = useContext(SiteBuilderContext)
  const widgetProps: IWidgetProps = {
    ...staticParams,
    ...routeParams,
    widgetParams,
    metrics,
    flexWidth,
    onChangeCustomSettings,
    widgetWidth,
    onToggleColumnWidth,
    AppWidgets,
    fullWidth,
    customSettings,
    isFullScreen,
    onCloseFullScreen,
    onOpenFullScreen,
  }
  const props = {
    viewModel,
    props: widgetProps,
  }
  const AppWidgetsComponent = <AppWidgets {...props} />
  const hasLayout = !isChildNull(AppWidgetsComponent, props)
  if (hasLayout) {
    return AppWidgetsComponent
  }

  const emptyProps = { ...widgetProps, name: viewModel }

  return <EmptyWidget {...emptyProps} />
}
